<template>
  <div>
    <ul class="icon-menu">
      <li class="icon-box home">
        <font-awesome-icon class="item" icon="fa-solid fa-circle-info" />
        <router-link :to="pathExplicacion"> Explicación</router-link>
      </li>

      <li class="icon-box design">
        <font-awesome-icon class="item" icon="fa-solid fa-desktop" />
        <router-link :to="pathDemostracion"> Demostración</router-link>
      </li>

      <li class="icon-box coding">
        <font-awesome-icon class="item" icon="fa-solid fa-shapes" />
        <router-link :to="pathActividad"> <h2>Actividad</h2></router-link>
      </li>

      <li class="icon-box shop">
        <font-awesome-icon class="item" icon="fa-solid fa-book-open" />
        <router-link :to="pathCuestionario"> <h2>Cuestionario</h2></router-link>
      </li>
      <li class="icon-box shop">
        <font-awesome-icon icon="fa-solid fa-door-open" />
        <router-link to="/menu"> <h2>Salir</h2></router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      pathExplicacion: "",
      pathDemostracion: "",
      pathActividad: "",
      pathCuestionario: "",
    };
  },
  props: {
    explicacion: String,
    demostracion: String,
    actividad: String,
    cuestionario: String,
  },
  watch: {
    cuestionario(nuevoValor, valorAnterior) {
      console.log(
        "El comenzar pasó de ser '%s' a '%s'",
        valorAnterior,
        nuevoValor
      );
    },
  },
  name: "MenuVertical",
  mounted() {
    this.establecerPath();
  },
  methods: {
    establecerPath() {
      const pathActual = this.$router.history.current.path;
      if (pathActual.includes("sistema-de-coordenadas")) {
        this.pathExplicacion = "sistema-de-coordenadas";
        this.pathDemostracion = "demostracion-sistema-de-coordenadas";
        this.pathActividad = "actividad-sistema-de-coordenadas";
        this.pathCuestionario = "cuestionario-sistema-de-coordenadas";
      } else if (pathActual.includes("transformadas")) {
        this.pathExplicacion = "transformadas-3d";
        this.pathDemostracion = "demostracion-transformadas-3d";
        this.pathActividad = "actividad-transformadas-3d";
        this.pathCuestionario = "cuestionario-transformadas-3d";
      } else if (pathActual.includes("cuaterniones")) {
        this.pathExplicacion = "cuaterniones";
        this.pathDemostracion = "demostracion-cuaterniones";
        this.pathActividad = "actividad-cuaterniones";
        this.pathCuestionario = "cuestionario-cuaterniones";
      }
    },
  },
};
</script>
<style scoped>
.menu {
  position: absolute;
  height: fit-content;
  /* width: 1rem; */
  top: -2rem;
  bottom: 0;
  margin: auto;
  margin-left: 0.6rem;
}
.icon-box {
  max-width: 1rem;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  color: white;
  margin-top: 1.5rem;
  cursor: pointer;
  font-size: 1.2rem;
}
.icon-box a {
  /* display: none; */
  padding-left: 1rem;
  position: relative;
  /* left: -200px; */

  width: 30rem;
  transform: translateX(-200px);
  font-size: 0.8rem;
  font-weight: bold;
}
.icon-box:hover a {
  transition-duration: 0.5s;
  display: inline;
  transform: translateX(0px);
  /* left: 0; */
}
</style>
